import Calendar_04_IconSolid from '@/components/icons/Calendar_04_IconSolid';
import Door_01_IconSolid from '@/components/icons/Door_01_IconSolid';
import Home_05_IconSolid from '@/components/icons/Home_05_IconSolid';
import { CalendarEventType } from '@/features/calendar/types/calendar-dto';
import { t } from 'i18next';

const getReservationDetails = (type: CalendarEventType) => {
    switch (type) {
        case CalendarEventType.Reservation:
            return {
                label: t('main.reservations.type.reservation'),
                icon: Calendar_04_IconSolid,
                iconColor: 'fill-warning-1000',
            };
        case CalendarEventType.Accommodation:
            return {
                label: t('main.reservations.type.accommodation'),
                icon: Home_05_IconSolid,
                iconColor: 'fill-info-1000',
            };
        case CalendarEventType.HouseUse:
            return {
                label: t('main.reservations.type.houseUse'),
                icon: Door_01_IconSolid,
                iconColor: 'fill-success-1000',
            };
    }
};

export const ReservationConfig = {
    getReservationDetails,
};
